import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { TelXLPanelComponent } from '@dxp/elements';
import { recalculateHeight } from '@dxp/core/helpers';
import { IContact } from '@dxp/core/models';
import { CommonModule } from '@angular/common';
import {
    ContactService,
    PermissionService,
    SettingsService,
} from '@dxp/core/services';
import { CONTACT_STORE } from '@dxp/core/stores';
import { ContactDirectoriesDetailsComponent } from './contact-details/contact-details.component';
import { ContactDetailsService } from './contact-details/contact-details.service';

@Component({
    selector: 'contact-directories',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ContactDirectoriesDetailsComponent,
        TelXLPanelComponent,
    ],
    providers: [ContactDetailsService],
    templateUrl: './contact-directories.component.html',
    styleUrl: './contact-directories.component.scss',
})
export class ContactDirectoriesComponent {
    readonly #settingsService = inject(SettingsService);
    readonly #permissionService = inject(PermissionService);
    readonly #contactService = inject(ContactService);
    readonly #contactStore = inject(CONTACT_STORE);

    autoRefreshOnUpdate = input<boolean>(false);
    contact = input.required<IContact>();
    updated = output<IContact>();

    height = computed<string>(() =>
        recalculateHeight('communication', this.#settingsService.viewType()),
    );

    hasPermission = computed(() =>
        this.#permissionService.hasAnyPermission(['contactdirectory.read']),
    );

    onUpdated(contact: IContact) {
        /**
         * Refreshes the parent directory list
         * Updates the store data - When the form is updated
         */
        if (this.autoRefreshOnUpdate()) {
            this.#contactService.setContactUpdate({
                type: 'contacts',
                contact,
            });
            this.#contactStore.updateSelectedContact({
                ...contact,
                object: JSON.stringify(contact),
                name: contact.fullName,
                id: `${contact.id}`,
            });
        }

        this.updated.emit(contact);
    }
}
